import { css } from 'styled-components';

const bgColor = `245, 246, 246`;
const bgColorMaskGradient = `var(--color-background, rgb(${bgColor})) 25%, var(--color-background-transparent, rgba(${bgColor}, 0))`;
const background = (breakpoint) =>
  breakpoint === 's'
    ? 'transparent'
    : `var(--color-background, rgb(${bgColor}))`;

const arrowStyle = (breakpoint) => css`
  top: 0px;
  margin-top: 8px;
  height: 100%;
  display: flex;
  align-items: center;
  pointer-events: none;
  padding-top: ${{
    s: 22,
    m: 25,
    l: 57,
    xl: 50,
  }[breakpoint]}px;
`;

const leftArrowStyle = (breakpoint) => css`
  ${arrowStyle(breakpoint)}
  justify-content: flex-start;
`;

const rightArrowStyle = (breakpoint) => css`
  ${arrowStyle(breakpoint)}
  justify-content: flex-end;
`;

export const leftArrow = (breakpoint) => css`
  ${leftArrowStyle(breakpoint)}
  margin-left: -8px;
  width: 16px;
  background: ${background(breakpoint)};
`;

export const rightArrow = (breakpoint) => css`
  ${rightArrowStyle(breakpoint)}
  margin-right: ${breakpoint === 's' ? 8 : 0}px;
  width: 12px;
  background: ${background(breakpoint)};
`;

export const customLeftArrow = (breakpoint) => css`
  ${leftArrowStyle(breakpoint)}
  margin-left: -10px;
  padding-left: 12px;
  width: 30px;
  background: linear-gradient(to right, ${bgColorMaskGradient});
`;

export const customRightArrow = (breakpoint) => css`
  ${rightArrowStyle(breakpoint)}
  margin-right: 2px;
  padding-right: 8px;
  width: 128px;
  background: linear-gradient(to left, ${bgColorMaskGradient});
`;

export const customArrowStyle = (breakpoint) => ({
  leftArrowStyle:
    breakpoint === 'm' ? customLeftArrow(breakpoint) : leftArrow(breakpoint),
  rightArrowStyle:
    breakpoint === 'm' ? customRightArrow(breakpoint) : rightArrow(breakpoint),
  isSmall: true,
});
